import { TrackEvent } from '@alycecom/services';

const analyticOptions = { app: { name: 'unsubscribe' } };
export const analyticService = TrackEvent.createAnalyticService({
  prefix: '',
  options: analyticOptions,
  staticPayload: {},
});
